<template>
    <v-row class="activity">
        <v-col class="px-md-0 py-6 ">
            <div class="content">
                <v-row :class="{ 'flex-row-reverse': reverse }">
                    <v-col cols="12" md="6" lg="5" class="px-md-0">
                        <div class="activity-content">
                            <v-row class="ma-0">
                                <v-col cols="2" class="pa-0 d-flex justify-center">
                                    <v-avatar color="primary" size="40">
                                        <span class="white--text font-weight-bold">{{ index }}</span>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="10" class="pa-0 pl-md-3 d-flex flex-column black--text">
                                    <h3 class="activity-title">
                                        <a
                                            :href="activity.url || '#'"
                                            target="_blank"
                                        >
                                            {{ activity.title }}
                                        </a>
                                    </h3>

                                    <p class="activity-type">{{ activity.type }}</p>

                                    <p
                                        v-html="activity.content"
                                        class="activity-text"
                                    ></p>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col
                        cols="12"
                        md="6"
                        class="px-md-0"
                        :class="(reverse ? 'pr-md-3' : 'pl-md-3')"
                    >
                        <div class="activity-image-wrapper">
                            <v-img
                                eager
                                :src="getImageUrl(activity.image)"
                                :alt="activity.title"
                            ></v-img>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { getMediaPathUrl } from '@/utils/helpers';

export default {
    name: "ActivityBlock",

    props: {
        activity: {
            type: Object,
            required: true,
        },

        index: {
            type: Number,
            default: 1,
        },

        reverse: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        getImageUrl(image) {
            try {
                return getMediaPathUrl(image);
            } catch (thrown) {
                return '';
            }
        },
    },
}
</script>

<style scoped>
/** Activity Block styles */
div.activity .content {
    max-width: 1505px;
    width: 100%;
    margin: 0;
    padding: 0;
    text-align: left;
    z-index: 2;
}

div.activity .activity-content {
    width: 100%;
    height: 100%;
    display: inline-flex;
    align-items: center;
}

div.activity .activity-content .v-avatar {
    font-size: 20px;
    line-height: 20px;
}

div.activity .activity-title {
    width: fit-content;
    font-size: 28px;
    line-height: 40px;
    text-decoration: 2px solid underline;
}

div.activity .activity-title,
div.activity .activity-title>a {
    transition: 0.3s all ease-in-out;
    color: #000;
}

div.activity .activity-title:hover,
div.activity .activity-title>a:hover {
    color: #2d76e3;
}

div.activity .activity-type {
    color: #2d76e3;
    font-size: 16px;
    line-height: 40px;
    font-weight: 600;
    text-transform: uppercase;
}

div.activity .activity-text {
    padding-top: 20px;
}

div.activity .activity-text>>>a {
    text-decoration: underline !important;
}

div.activity .activity-image-wrapper {
    max-height: 360px;
    overflow: hidden;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%),
        0 4px 5px 0 rgb(0 0 0 / 14%),
        0 1px 10px 0 rgb(0 0 0 / 12%);
}
</style>
